<template>
    <div :class="['contextError', errorStore.type === ErrorType.warning ? 'warningType' : 'errorType']" v-show="show">
        <div class="textSection">
		{{ errorStore.text }}<br/>
        </div>
        <div class="buttonSection">
            <div type="button" class="errorCloseButton" @click="closeError">
							<span class="icon-close"></span>
						</div>
        </div>
    </div>
</template>

<script setup lang="js">
import { computed, defineProps } from "vue";
import { ErrorType, ErrorLocationType } from "@/utilities/enums/Enums";
import {useErrorStore} from "@/stores/ErrorStore";

const props = defineProps({
    errorLoc: ErrorLocationType
});

const errorStore = useErrorStore();

const show = computed(()=> props.errorLoc === errorStore.location);

const closeError = ()=>{
  errorStore.location = ErrorLocationType.none;
};
</script>

<style lang="scss">
.contextError{
		@apply pl-2 py-1 my-1;
    display: flex;
}
.warningType{
    background-color: $summerYellow;
    color: $white;
}
.errorType{
    background-color: $statusAlert;
    color: $white;
}
.successType{
	background-color: $statusOk;
	color: $white;
}
.textSection{
    flex-grow: 1;
		font-size: 14px;
}
.buttonSection{
	@apply px-2;
	font-size: 14px;
	&:hover {
		cursor: pointer;
	}
}
.errorCloseButton{
    background-color: transparent;
    border: none;
}
</style>
